import { useEffect, useState } from 'react';
import { useNavigation } from 'react-router-dom';
import { BrandSpinner } from '@platform/ui';

const SHOW_DELAY_MS = 150;

export function RouteLoadingOverlay() {
  const { state } = useNavigation();
  const isLoading = state !== 'idle';
  const [readyToShow, setReadyToShow] = useState(false);

  // SHOW_DELAY_MS 이상 걸릴 때만 스피너 표시 (빠른 전환 시 깜빡임 방지).
  // setState 는 cleanup 안에서만 호출 — react-hooks/set-state-in-effect 회피.
  useEffect(() => {
    if (!isLoading) return;
    const timer = setTimeout(() => setReadyToShow(true), SHOW_DELAY_MS);
    return () => {
      clearTimeout(timer);
      setReadyToShow(false);
    };
  }, [isLoading]);

  const visible = isLoading && readyToShow;

  // 🐛 디자인 확인용 강제 표시 (hook 호출 이후여야 rules-of-hooks 위반 없음)
  if (import.meta.env.DEV && window.location.search.includes('debug-spinner')) {
    return (
      <div className="fixed inset-0 z-[9999] grid place-items-center bg-black/40 backdrop-blur-sm">
        <BrandSpinner size={64} />
      </div>
    );
  }

  if (!visible) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] grid place-items-center bg-black/40 backdrop-blur-sm"
      role="status"
      aria-live="polite"
    >
      <BrandSpinner size={64} />
    </div>
  );
}
